const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/store.ts';
import { DependencyList, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CommonStoreState } from '../reducers';

export const selectNothing = (state: CommonStoreState) => undefined;

export const useMadeSelector = <T, S>(selectorFactory: () => (state: S) => T, dependencies: DependencyList = []): T => {
    const memoizedSelector = useMemo(selectorFactory, dependencies);
    return useSelector(memoizedSelector);
};
